export const ATTRIBUTE_BUNDLE_SETTINGS_CONSTANTS = {
  FEATURE_INFO_ENABLED: 'featureInfo.enabled',
  FEATURE_INFO_AUTO_MODE_ENABLED: 'featureInfo.auto.enabled',
  FEATURE_INFO_HEADLINE_TYPE: 'featureInfo.headline.mode',
  FEATURE_INFO_HEADLINE_CUSTOM: 'featureInfo.headline.custom',
  FEATURE_INFO_PIE_CHART_SLICE_RESOLVING_ENABLED: 'featureInfo.pieChartSliceResolving.enabled'
};

